export default __webpack_public_path__ + "static/media/help-left-img.4336494f.png";